<template>
  <div class="user-component">
    <div class="user-avatar clickable"
         :class="hasAvatar ? 'has-avatar' : 'no-avatar'"
         @click.prevent.stop="show = !show"
    >
      <div v-if="hasAvatar" class="user-avatar-content" :style="`background-image: url('${user.getAvatar()}')`"></div>
      <div v-else class="user-avatar-content">{{ user.getInitials() }}</div>
    </div>

    <div class="user-dropdown" v-if="show">
      <div class="user-dropdown-row">
        <div class="user-avatar"
             :class="hasAvatar ? 'has-avatar' : 'no-avatar'"
        >
          <div v-if="hasAvatar" class="user-avatar-content" :style="`background-image: url('${user.getAvatar()}')`"></div>
          <div v-else class="user-avatar-content">{{ user.getInitials() }}</div>
        </div>
        <div class="user-meta">
          <div class="user-meta-name">{{ user.getName() }}</div>
          <div class="user-meta-email">{{ user.getEmail() }}</div>
        </div>
      </div>
      <div class="user-dropdown-row sign-out-row">
        <a @click.prevent="user.signOut()">
          <button class="compact rect outline">{{ $t('sign-out') }}</button>
        </a>
      </div>
      <div class="user-dropdown-row language-toggle-row">
        <a @click.prevent="toggleLanguage">
          {{ $t('toggle-language') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import Manager from "./Manager";

const user = Manager.getInstance().user
const route = useRoute();

const show = ref(false);

const hasAvatar = !!user.getAvatar();

const toggleLanguage = () => {
  let pathComponents = window.location.pathname.split('/');
  const queryParameters = window.location.search
  pathComponents[1] = Manager.getInstance().i18n.global.locale == 'en' ? 'fr' : 'en';
  const url = `${pathComponents.join('/')}${queryParameters}`;
  window.location.href = url;
}

document.addEventListener('click', () => {
  show.value = false;
});
</script>
